import React, { Fragment, useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import routes from "./routes/index";
import { Affix } from "antd";
import Header from "./components/headerLogin";
import SubHeader from "./components/subHeader"
import LoadingPage from "./components/LoadingPage"
import Footer from "./components/Footer"

const App: React.FC = () => {
  const [loading, setLoading] = useState(true);

  setTimeout(()=>{
    setLoading(false)
  },3000)

  return (
    <Fragment>
      {!loading ? <Header /> : <></>}
      {!loading && <SubHeader />}
      {!loading ? (
        <Routes>
          {routes.map((route) => (
            <Route key={route.key} path={route.path} element={route.element} />
          ))}
        </Routes>
      ) : (
        <LoadingPage/>
      )}
      <Footer/>
    </Fragment>
  );
};

export default App;
